<template>
  <div class="report-center">
    <h1 class="page-title">新疆音线网举报中心</h1>
    
    <div class="report-content">
      <div class="report-intro">
        <p>为进一步发挥网络举报工作在维护企业网络合法权益、优化营商网络环境中的重要作用，努尔网开设"举报专区"，专项受理网站上发布的涉企网络侵权信息举报。</p>
      </div>
      
      <div class="report-section">
        <h2>一、受理范围</h2>
        <p>努尔网站平台上编造传播的损害企业及企业家名誉的虚假不实信息。</p>
        <ul>
          <li>（一）混淆企业主体身份的仿冒性信息；</li>
          <li>（二）影响公众公正评判的误导性信息；</li>
          <li>（三）不符合企业客观实际的谣言性信息；</li>
          <li>（四）贬损丑化企业或企业家的侮辱性信息；</li>
          <li>（五）侵害企业家个人隐私的泄密性信息；</li>
          <li>（六）其他恶意干扰企业正常经营发展的信息；</li>
          <li>（七）网页内容包含的错误信息；</li>
          <li>（七）与该公司的民事申诉问题；</li>
        </ul>
      </div>
      
      <div class="report-section">
        <h2>二、受理条件</h2>
        <p>举报需由涉事企业或涉事企业委托的代理人提起，并满足以下条件：</p>
        <ul>
          <li>（一）提交能够充分陈述举报事项、阐明举报理由的文字举报；</li>
          <li>（二）提交举报人姓名、联系方式；</li>
          <li>（三）提交请求采取必要措施的具体网络地址或者足以准确定位侵权内容的相关信息；</li>
          <li>（四）提交能够证明举报内容侵权的初步证据材料；</li>
          <li>（五）提交申明举报真实性、合法性的文字保证。</li>
        </ul>
      </div>
      
      <div class="report-section">
        <h2>三、填写要求</h2>
        <p>应填写企业相关信息、联系方式和相关举报材料。请勿就同一事项重复举报。</p>
      </div>
      
      <div class="report-section">
        <h2>四、注意事项</h2>
        <ol>
          <li>举报主体应对举报事项的客观性、真实性负责，不得提造事实、伪造身份及证明证据。</li>
          <li>不得在举报内容中发表违反中华人民共和国宪法和法律的言论，举报主体承担一切因违法留言行为而引起的法律责任。</li>
          <li>举报人应按照提示要求填写举报信息，提供举报材料，请勿就同一事项重复举报。</li>
          <li>提倡实名举报，请留下有效联系方式，以便工作人员和您取得联系。</li>
        </ol>
      </div>
      
      <div class="report-section">
        <h2>五、举报热线</h2>
        <ol>
          <li>新疆音线网举报电话：15160945581</li>
          <li>新疆音线网侵权类信息举报电话：15160945581</li>
          <li>新疆音线网举报邮箱：2756825623@qq.com</li>
          <li>新疆互联网违法和不良信息举报中心：0991-2384777</li>
          <li>新疆互联网违法和不良信息举报中心：jbzx@cax.gov.cn</li>
        </ol>
      </div>
      
      <div class="report-section">
        <h2>六、举报网址与入口</h2>
        <ol>
          <li>新疆互联网违法和不良信息举报中心：<a href="https://www.xjwljb.com/home" target="_blank">https://www.xjwljb.com/home</a></li>
          <li>新疆互联网联合辟谣平台：<a href="https://www.xjwljb.com/piyao/web/home" target="_blank">https://www.xjwljb.com/piyao/web/home</a></li>
          <li>新疆各地州网络举报电话：<a href="https://www.xjwljb.com/phone" target="_blank">https://www.xjwljb.com/phone</a></li>
          <li>网络谣言曝光台：<a href="https://www.piyao.org.cn/yybgt/index.htm" target="_blank">https://www.piyao.org.cn/yybgt/index.htm</a></li>
          <li>涉未成年人网上有害信息：<a href="https://www.xjwljb.com/home" target="_blank">https://www.xjwljb.com/home</a></li>
          <li>涉企网络侵权举报专区：<a href="https://www.12377.cn/jbxxq/sgl_web.html" target="_blank">https://www.12377.cn/jbxxq/sgl_web.html</a></li>
        </ol>
      </div>
      
      <div class="report-buttons">
        <button class="report-btn" @click="goToNationalReportCenter">
          <img src="../assets/platform-icon.png" alt="中国互联网举报中心" />
          <span>中国互联网举报中心</span>
        </button>
        <button class="report-btn" @click="goToXinjiangReportCenter">
          <img src="../assets/platform-icon.png" alt="新疆互联网举报中心" />
          <span>新疆互联网举报中心</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportCenter',
  methods: {
    goToNationalReportCenter() {
      window.open('https://www.12377.cn/', '_blank');
    },
    goToXinjiangReportCenter() {
      window.open('https://www.xjwljb.com/home', '_blank');
    },
    goToReportForm() {
      // 这里可以跳转到站内举报表单页面
      // this.$router.push('/report-form');
      alert('举报表单功能即将上线');
    }
  }
}
</script>

<style scoped>
.report-center {
  padding: 30px;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.page-title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 30px;
  color: #333;
}

.report-content {
  line-height: 1.8;
  color: #333;
}

.report-intro {
  margin-bottom: 20px;
  text-indent: 2em;
}

.report-section {
  margin-bottom: 30px;
}

.report-section h2 {
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: 500;
}

.report-section ul, 
.report-section ol {
  padding-left: 2em;
  margin-bottom: 15px;
}

.report-section li {
  margin-bottom: 10px;
}

.report-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 40px;
}

.report-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: all 0.3s;
  width: 200px;
}

.report-btn:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.report-btn img {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
  object-fit: contain;
}

.report-btn span {
  font-size: 16px;
  color: #333;
}

.report-btn.primary {
  background-color: #4169e1;
  border-color: #4169e1;
}

.report-btn.primary span {
  color: #fff;
  font-weight: 500;
}

a {
  color: #4169e1;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style> 